// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field {
  display: flex;
  flex-direction: column;
  width: -moz-fit-content;
  width: fit-content;
}

.field-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: stretch;
}

form {
  margin-bottom: 2rem;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 1rem;
  margin-bottom: 2rem;
}

.groups-field {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.groups-field .group-field {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(18rem, auto));
  gap: 1rem;
}
.groups-field button {
  margin-top: 1rem;
  width: -moz-fit-content;
  width: fit-content;
}

.translations {
  margin: 2rem 0;
}

p-footer {
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
  margin-top: 2rem;
}

.remuneration-form {
  display: flex;
  flex-direction: column;
}
.remuneration-form .field {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.remuneration-form .field button {
  align-self: flex-start;
}
.remuneration-form button {
  align-self: flex-end;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBhbnktZWRpdC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLGFBQUE7RUFDQSxzQkFBQTtFQUNBLHVCQUFBO0VBQUEsa0JBQUE7QUFDSjs7QUFFQTtFQUNJLGFBQUE7RUFDQSxtQkFBQTtFQUNBLGVBQUE7RUFDQSxTQUFBO0VBQ0Esb0JBQUE7QUFDSjs7QUFFQTtFQUNJLG1CQUFBO0FBQ0o7O0FBRUE7RUFDSSxhQUFBO0VBQ0EsOEJBQUE7RUFDQSxvQkFBQTtFQUNBLFNBQUE7RUFDQSxtQkFBQTtBQUNKOztBQUVBO0VBQ0ksYUFBQTtFQUNBLHNCQUFBO0VBQ0EsU0FBQTtBQUNKO0FBQ0k7RUFDSSxhQUFBO0VBQ0EsNkRBQUE7RUFDQSxTQUFBO0FBQ1I7QUFFSTtFQUNJLGdCQUFBO0VBQ0EsdUJBQUE7RUFBQSxrQkFBQTtBQUFSOztBQUlBO0VBQ0ksY0FBQTtBQURKOztBQUlBO0VBQ0ksYUFBQTtFQUNBLDJCQUFBO0VBQ0EsU0FBQTtFQUNBLGdCQUFBO0FBREo7O0FBSUE7RUFDSSxhQUFBO0VBQ0Esc0JBQUE7QUFESjtBQUdJO0VBQ0ksYUFBQTtFQUNBLG1CQUFBO0VBQ0EsU0FBQTtBQURSO0FBR1E7RUFDSSxzQkFBQTtBQURaO0FBS0k7RUFDSSxvQkFBQTtBQUhSIiwiZmlsZSI6ImNvbXBhbnktZWRpdC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5maWVsZCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIHdpZHRoOiBmaXQtY29udGVudDtcbn1cblxuLmZpZWxkLWdyb3VwIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgZmxleC13cmFwOiB3cmFwO1xuICAgIGdhcDogMXJlbTtcbiAgICBhbGlnbi1pdGVtczogc3RyZXRjaDtcbn1cblxuZm9ybSB7XG4gICAgbWFyZ2luLWJvdHRvbTogMnJlbTtcbn1cblxuLmFjdGlvbnMge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIGFsaWduLWl0ZW1zOiBzdHJldGNoO1xuICAgIGdhcDogMXJlbTtcbiAgICBtYXJnaW4tYm90dG9tOiAycmVtO1xufVxuXG4uZ3JvdXBzLWZpZWxkIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgZ2FwOiAxcmVtO1xuXG4gICAgLmdyb3VwLWZpZWxkIHtcbiAgICAgICAgZGlzcGxheTogZ3JpZDtcbiAgICAgICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiByZXBlYXQoYXV0by1maWxsLCBtaW5tYXgoMThyZW0sIGF1dG8pKTtcbiAgICAgICAgZ2FwOiAxcmVtO1xuICAgIH1cblxuICAgIGJ1dHRvbiB7XG4gICAgICAgIG1hcmdpbi10b3A6IDFyZW07XG4gICAgICAgIHdpZHRoOiBmaXQtY29udGVudDtcbiAgICB9XG59XG5cbi50cmFuc2xhdGlvbnMge1xuICAgIG1hcmdpbjogMnJlbSAwO1xufVxuXG5wLWZvb3RlciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogcm93LXJldmVyc2U7XG4gICAgZ2FwOiAxcmVtO1xuICAgIG1hcmdpbi10b3A6IDJyZW07XG59XG5cbi5yZW11bmVyYXRpb24tZm9ybSB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuXG4gICAgLmZpZWxkIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICAgICAgZ2FwOiAxcmVtO1xuXG4gICAgICAgIGJ1dHRvbiB7XG4gICAgICAgICAgICBhbGlnbi1zZWxmOiBmbGV4LXN0YXJ0O1xuICAgICAgICB9XG4gICAgfVxuXG4gICAgYnV0dG9uIHtcbiAgICAgICAgYWxpZ24tc2VsZjogZmxleC1lbmQ7XG4gICAgfVxufVxuIl19 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/invoicing/company/company-edit/company-edit.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AACI;EACI,aAAA;EACA,6DAAA;EACA,SAAA;AACR;AAEI;EACI,gBAAA;EACA,uBAAA;EAAA,kBAAA;AAAR;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,aAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,sBAAA;AADJ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AADR;AAGQ;EACI,sBAAA;AADZ;AAKI;EACI,oBAAA;AAHR;AAGA,w6EAAw6E","sourcesContent":[".field {\n    display: flex;\n    flex-direction: column;\n    width: fit-content;\n}\n\n.field-group {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 1rem;\n    align-items: stretch;\n}\n\nform {\n    margin-bottom: 2rem;\n}\n\n.actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.groups-field {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n\n    .group-field {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(18rem, auto));\n        gap: 1rem;\n    }\n\n    button {\n        margin-top: 1rem;\n        width: fit-content;\n    }\n}\n\n.translations {\n    margin: 2rem 0;\n}\n\np-footer {\n    display: flex;\n    flex-direction: row-reverse;\n    gap: 1rem;\n    margin-top: 2rem;\n}\n\n.remuneration-form {\n    display: flex;\n    flex-direction: column;\n\n    .field {\n        display: flex;\n        flex-direction: row;\n        gap: 1rem;\n\n        button {\n            align-self: flex-start;\n        }\n    }\n\n    button {\n        align-self: flex-end;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
